/**
 * 模組頁面代碼 :
 * 頁面說明 : 底部元件
 * @module features/main-frame/Footer.jsx
 */

// ----- import from base components -----
import {React} from '../../../components/BaseComponent';

const Footer = () => {
  return (
    <div className="footer-container">
      <footer className="c__footer">COPYRIGHT © CENTURY TRADING CO.,LTD. ALL RIGHTS RESERVED</footer>
    </div>
  );
};

export default Footer;
